import React from 'react';

import AttentionMessage, { AttentionMessageProps } from './AttentionMessage';
import AttentionMessageTypes from './AttentionMessageTypes';

export enum InfoMessageTypes {
    INFO = AttentionMessageTypes.INFO,
    DEFAULT = AttentionMessageTypes.DEFAULT,
    ATTENTION = AttentionMessageTypes.ATTENTION,
}

export type InfoMessageProps = Omit<AttentionMessageProps, 'type'> & {
    type?: AttentionMessageTypes.INFO | AttentionMessageTypes.ATTENTION | AttentionMessageTypes.DEFAULT;
};

const InfoMessage = ({ type, ...rest }: InfoMessageProps): JSX.Element => (
    <AttentionMessage type={(type as unknown as AttentionMessageTypes) || AttentionMessageTypes.INFO} {...rest} />
);

export default InfoMessage;
